import { toast } from '@/hooks/use-toast';
import { Check, AlertCircle, AlertTriangle } from 'lucide-react';
import { createElement, type ReactNode } from 'react';
import i18next from 'i18next';

interface ToastOptions {
    title?: string;
    description: string;
    duration?: number;
    action?: {
      label: string;
      onClick: () => void;
    };
    cancel?: {
      label: string;
      onClick: () => void;
    };
    onOpenChange?: (open: boolean) => void;
    variant?: 'default' | 'destructive';
    icon?: ReactNode;
    className?: string;
  }

export const showToast = {
  success: ({ 
    title = i18next.t('common.success', 'Success'), 
    description, 
    duration = 3000,
    action,
    cancel,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'default',
      icon: createElement(Check, { className: "h-4 w-4 text-green-500" }),
      className: 'border-green-200 bg-green-50',
      action,
      cancel,
      onOpenChange
    });
  },

  error: ({ 
    title = i18next.t('common.error', 'Error'), 
    description, 
    duration = 5000,
    action,
    cancel,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'destructive',
      icon: createElement(AlertCircle, { className: "h-4 w-4" }),
      action,
      cancel,
      onOpenChange
    });
  },

  warning: ({ 
    title = i18next.t('common.warning', 'Warning'), 
    description, 
    duration = 4000,
    action,
    cancel,
    onOpenChange
  }: ToastOptions) => {
    toast({
      title,
      description,
      duration,
      variant: 'default',
      icon: createElement(AlertTriangle, { className: "h-4 w-4 text-yellow-500" }),
      className: 'border-yellow-200 bg-yellow-50',
      action,
      cancel,
      onOpenChange
    });
  }
}; 